import React, { useState } from 'react';
import { useAuth } from "react-oidc-context"
import { getClaimValue } from "../../utils/authUser";
import LimeClaimTypes from "../../models/limeClaimTypes";
import { composeUrl } from "../../utils/api";
import OnboardingTaskItem from "./OnboardingTaskItem";
import { OnboardingStatus, OnboardingTask } from "./types";
import { formatViewDate } from "../../utils/dateFormat";
import { portalPageTitle, portalPageSubtitle } from "../../theme/portalLayout";
import {
  dashboardGrid,
  dashboardHero,
  dashboardPage,
  dashboardStatCard,
} from "../../theme/dashboardLayout";

function OnboardingDashboard() {
  const auth = useAuth();
  const [name, setName] = useState<string | undefined>();
  const [startDate, setStartDate] = useState<string | undefined>();
  const [tasks, setTasks] = useState<OnboardingTask[]>([]);

  React.useEffect(() => {
    setName(getClaimValue(auth.user, "nickname"));

    const orgUuid = getClaimValue(auth.user, LimeClaimTypes.OrganisationUuid);
    fetch(composeUrl(`organisations/${orgUuid}/onboarding`),
      {
        headers: [['Authorization', `Bearer ${auth.user?.access_token}`]],
        method: 'GET'
      })
      .then(response => response.json() as Promise<OnboardingStatus>)
      .then(data => {
        const date = formatViewDate(new Date(data.startDate));
        setStartDate(date);
        setTasks(data.tasks);
      } );
  }, [auth.user]);

  const yours = tasks.filter(task => task.isAllowed);
  const others = tasks.filter(task => !task.isAllowed);

  return (
      <div className={dashboardPage}>
        <header className={dashboardHero}>
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-portal-teal/55">
            Getting started
          </p>
          <h1 className={`mt-2 ${portalPageTitle}`}>Hello {name}</h1>
          <p className={`mt-3 max-w-2xl ${portalPageSubtitle}`}>
            Your organisation must complete the tasks below before <b>{startDate}</b> to get started.
          </p>
        </header>

        <div className={dashboardGrid}>
          {yours.length > 0 && (
            <section className={`${dashboardStatCard} sm:col-span-2 xl:col-span-3`}>
              <h2 className="text-[11px] font-semibold uppercase tracking-[0.16em] text-portal-teal/65">
                For you
              </h2>
              <ul className="mt-5 list-none space-y-3 p-0">
                {yours.map((task, index) => (
                  <OnboardingTaskItem key={index} task={task} />
                ))}
              </ul>
            </section>
          )}

          {others.length > 0 && (
            <section className={`${dashboardStatCard} sm:col-span-2 xl:col-span-3`}>
              <h2 className="text-[11px] font-semibold uppercase tracking-[0.16em] text-portal-teal/65">
                For others
              </h2>
              <ul className="mt-5 list-none space-y-3 p-0">
                {others.map((task, index) => (
                  <OnboardingTaskItem key={index} task={task} />
                ))}
              </ul>
            </section>
          )}
        </div>
      </div>
    );
}

export default OnboardingDashboard;
